import { FC } from 'react'
import * as styles from 'styles/molecules/tables/Table.css'
import { FooterDefinition } from 'interfaces/table'

type TableFooterProps<TProps> = {
  definition: FooterDefinition<TProps>[]
  rows: TProps[]
}

export type TableFooterType<TProps> = FC<TableFooterProps<TProps>>

function TableFooter <TProps> ({ definition, rows }: TableFooterProps<TProps>) {
  return (
    <tfoot className={ styles.footer } data-qa-marker='table-footer'>
      <tr className={ styles.row } data-qa-type='table-row'>
        {
          definition.map(({ propsReducer, component, title }, idx) => (
            <td className={ styles.cell } key={ idx } data-qa-type='table-cell'>
              { title ? <h3 className={ styles.responsiveTitle }>{ title }</h3> : null }
              { component(propsReducer(rows)) }
            </td>
          ))
        }
      </tr>
    </tfoot>
  )
}

export default TableFooter
